module.exports = __webpack_public_path__ + "static/the-seven-husbands-of-evelyn-hugo-463e854bd22a769c70b005f39dfe75f7.jpg";